import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { RealNameConsentModal } from "./RealNameConsentModal";

/**
 * 기존 정회원 이상이지만 실명/노출 동의가 없는 회원에게 로그인 후 프로필 보완 안내 팝업.
 * needs_real_name 플래그(백엔드 계산)를 기준으로 표시.
 */
export function RealNamePrompt() {
  const { user, isAuthenticated } = useAuth();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!isAuthenticated || !user) { setOpen(false); return; }
    // 관리자/운영 계정은 실명 보완 대상에서 제외
    const isAdmin = user.is_admin || user.role === "admin" || (user.email || "").toLowerCase() === "admin@newcoupling.com";
    const dismissed = sessionStorage.getItem("nc_realname_prompt_dismissed");
    if (user.needs_real_name && !isAdmin && !dismissed) {
      setOpen(true);
    } else {
      setOpen(false);
    }
  }, [isAuthenticated, user]);

  const close = () => {
    sessionStorage.setItem("nc_realname_prompt_dismissed", "1");
    setOpen(false);
  };

  if (!open) return null;

  return (
    <RealNameConsentModal
      open={open}
      onClose={close}
      onConfirmed={close}
      title="프로필 보완 안내 — 실명 입력 필요"
      confirmLabel="실명 저장하기"
    />
  );
}

export default RealNamePrompt;
